import { campaignObjectives } from '../../../opportunities/constants';

export const MIN_POSTCLICK_ROAS = {
  label: 'Min. Postclick ROAS',
  value: 'Min. Postclick ROAS',
  recommendationField: 'pcROAS',
};

export const MIN_TOTAL_ROAS = {
  label: 'Min. Total ROAS',
  value: 'Min. Total ROAS',
  recommendationField: 'totalROAS',
};

export const COST_PER_UU = {
  label: 'Cost per UU',
  value: 'Cost per UU',
  currency: true,
  defaultValue: 0.25,
};

export const TOTAL_CPE = {
  label: 'Total CPE',
  value: 'Total CPE',
  recommendationField: 'totalCPE',
  currency: true,
};

export const POSTCLICK_CPE = {
  label: 'Postclick CPE',
  value: 'Postclick CPE',
  recommendationField: 'pcCPE',
  currency: true,
};

export const MERCHANT_ROAS = {
  label: 'Merchant ROAS',
  value: 'Merchant ROAS',
  recommendationField: 'merchantROAS',
};

export const ROAS = {
  label: 'ROAS',
  value: 'ROAS',
  recommendationField: 'ROAS',
  isDisabled: false,
};

export const CPE = {
  label: 'CPE',
  value: 'CPE',
  currency: true,
  isDisabled: true,
};
export const MIN_ROAS = {
  label: 'Min. ROAS',
  value: 'Min. ROAS',
  isDisabled: true,
};

export const awarenessTargetKpi = [COST_PER_UU];

export const engagementTargetKpi = [POSTCLICK_CPE];

export const performanceTargetKpi = [ROAS];

export const otherTargetKpi = [COST_PER_UU, CPE, ROAS];

export const allTargetKpis = [
  COST_PER_UU,
  TOTAL_CPE,
  POSTCLICK_CPE,
  MIN_TOTAL_ROAS,
  MIN_POSTCLICK_ROAS,
  MERCHANT_ROAS,
  CPE,
  MIN_ROAS,
  ROAS,
];

export const targetKpiOptions = {
  [campaignObjectives.AWARENESS]: awarenessTargetKpi,
  [campaignObjectives.ENGAGEMENT]: engagementTargetKpi,
  [campaignObjectives.PERFORMANCE]: performanceTargetKpi,
  [campaignObjectives.OTHER]: otherTargetKpi,
};
